<script>
export default {};
</script>

<template lang='pug'>
keep-alive(exclude='Campaign')
  router-view
</template>
